import CommonContainer from "../../Container/CommonContainer";
import { FaToggleOn, FaToggleOff, FaPen, FaBars, FaTrash } from "react-icons/fa";
import * as CaseCategoryService from "../../../Services/Masters/CaseCategory/CaseCategoryService";
import toast from "react-hot-toast";
import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";

const CaseCategoryComponent = () =>{

    const { register, handleSubmit, formState: { errors }, reset, } = useForm();

    const [caseCategoryList, setCaseCategoryList] = useState([]);
    const [selectedCaseCategory, setSelectedCaseCategory] = useState({});
    const [newCaseCategoryModal, setNewCaseCategoryModal] = useState(false);
    const [newCaseCategoryMappingModal, setNewCaseCategoryMappingModal] = useState(false);
    const [activeTab, setActiveTab] = useState("srtype");

    const fetchAllCaseCategoryMasterList = () => {
        CaseCategoryService.GetCaseCategoryList()
          .then(({ data }) => {
            if (data.IsSuccess) {
              setCaseCategoryList(data.Data);
            }
          })
          .catch(() => toast.error("Something went wrong."));
    };

    useEffect(() => {
        fetchAllCaseCategoryMasterList();
    },[]);

    const onSubmit = (data) => {
      //debugger;

      const recordTypeIds = [];

      if (data.IsSRComplaint) {
        recordTypeIds.push(data.IsSRComplaint);
      }

      if (data.IsSRRequest) {
        recordTypeIds.push(data.IsSRRequest);
      }

      const formattedJsonData = {
        Id: selectedCaseCategory?.Id,
        CaseCategory: data.CaseCategory,
        Record_Type_Ref_Id: recordTypeIds.join('|'),
        Sfdc_Category_Name: data.Sfdc_Category_Name,
      };

      if (selectedCaseCategory?.Id) {
        //data.Id = selectedCaseCategory?.Id;
        //data.Record_Type_Ref_Id = selectedCaseCategory
        CaseCategoryService.UpdateCaseCategory(formattedJsonData)
          .then(({ data }) => {
            if (data.IsSuccess) {
              fetchAllCaseCategoryMasterList();
              toast.success("Case Category updated successfully!");
              handleNewCaseCategoryModalClose();
            } else {
              toast.error("Something went wrong during update.");
            }
          })
          .catch(() => toast.error("Something went wrong during update."))
          .finally(() => { });
      } else {
        CaseCategoryService.CreateNewCaseCategory(formattedJsonData)
          .then(({ data }) => {
            if (data.IsSuccess) {
              fetchAllCaseCategoryMasterList();
              toast.success("Case Category saved successfully!");
              handleNewCaseCategoryModalClose();
            } else {
              toast.error(data.ResponseMessage);
            }
          })
          .catch(() => toast.error("Something went wrong during creation."))
          .finally(() => { });
      }
    };

    const handleNewCaseCategoryModalClose = () => {
      reset();
      setSelectedCaseCategory([]);
      setNewCaseCategoryModal(false)
      setActiveTab("srtype")
      setNewCaseCategoryMappingModal(false)
    };

    const handleActivateDeActivateCaseCategory = (rec) =>{
      CaseCategoryService.ActivateDeActivateCaseCategory(rec.Id, !rec.IsActive).then(data => {
        if (data.data.IsSuccess) {
          const message = rec.IsActive ? "Case Category DeActivated Successfully" : "Case Category Activated Successfully";
          toast.success(message);
          fetchAllCaseCategoryMasterList();
        } else {
          toast.error("Somthing went wrong");
        }
        //console.log("data", data)
      }).catch(error => {
        toast.error("Somthing went wrong");
      })
    }

    const handleViewCaseCategoryDetailById = (Id) => {
      //debugger;
      const selectedItem = caseCategoryList.find(item => item.Id === Id);
      if(selectedItem != null){
        setSelectedCaseCategory(selectedItem);
        setNewCaseCategoryModal(true);
      }
      else{
        selectedCaseCategory({});
      }
    };

    const handleViewCaseCategMappingDetails = (caseCategoryId) => {
      setNewCaseCategoryMappingModal(true);
    }

    return (
        <>
          {/* <LoadingSpinnerComponent></LoadingSpinnerComponent> */}
          <CommonContainer heading="Case Category List" buttonText="Add Case Category" onButtonClick={() => { reset(); setSelectedCaseCategory([]); setNewCaseCategoryModal(true)}}>
    
            <div className="d-flex align-items-center justify-content-between mb-2">
              <div className="d-flex align-items-center gap-2">
              </div>
              {/* <div className="search-box" style={{ position: "relative", width: "320px" }}>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search"
                  //ref={selectedSearchUser}
                  style={{
                    paddingRight: "35px",
                    borderRadius: "5px",
                    border: "1px solid #ddd",
                  }}
                />
                <button
                  type="button"
                  className="btn btn-success d-flex align-items-center justify-content-center"
                  style={{
                    padding: '5px',
                    position: "absolute",
                    right: "0px",
                    height: "35px",
                    width: "45px",
                    top: "50%",
                    borderTopLeftRadius: "0",
                    borderBottomLeftRadius: "0",
                    transform: "translateY(-50%)",
                  }}
                  //onClick={fetchUniversalFilterUserData}
                >
                  <FaSearch />
                </button>
    
              </div> */}
            </div>
            <div>
              <div className="table-responsive" >
                <table className="table table-bordered custom-table" >
                  <thead>
                    <tr>
                      <th> Case Category</th>
                      <th> Active </th>
                      <th> Action </th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      caseCategoryList.length > 0 ? (
                        caseCategoryList.map((rec, index) => (
                          <tr key={index} >
                            <td>{rec.CaseCategory}</td >
                            <td>
                              {rec.IsActive ? <FaToggleOn title="Deactivate CaseCategory" onClick={() => handleActivateDeActivateCaseCategory(rec)} color="green" size={16} /> : <FaToggleOff onClick={() => handleActivateDeActivateCaseCategory(rec)} title="Activate CaseCategory" color="red" size={16} />}
                            </td>
                            <td>
                              {/* <FaPenSquare color="green" className="mr-2 cursor-pointer" size={25} onClick={() => handleViewUserDetailById(rec.UserId)} title="Edit User" /> */}
                              <FaPen color="green" className="mr-2 cursor-pointer" onClick={() => handleViewCaseCategoryDetailById(rec.Id)} title="Edit CaseCategory" />
                              {/* <FaBars color={"green"} onClick={() => handleViewCaseCategMappingDetails(rec.Id)} title="Edit Mapping with Case Category"/> */}
                              {/* <FaTrash color={"red"} onClick={() => handleUserDelete(rec)} /> */}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr><td colSpan="9" className="text-center" > No Data found </td></tr >
                      )}
                  </tbody>
                </table>
              </div>
            </div>

            {newCaseCategoryModal && (
            <div className="modal-backdrop">
              <div className="modal fade show d-block" tabIndex="-1" role="dialog">
                <div className="modal-dialog modal-lg custom-modal" role="document">
                  <div className="modal-content mb-0 p-0">
                    <div className="modal-header p-2-5">
                      <h5 className="modal-title">{selectedCaseCategory?.CaseCategory ? "Edit Case Category" : "New Case Category"}</h5>
                      <button type="button" className="btn-close" onClick={handleNewCaseCategoryModalClose}></button>
                    </div>
                    <div className="modal-body p-1">
                      <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
                        <div className="container mb-0" style={{ fontSize: "13px" }}>

                          <div className="row">

                            <div className="col-md-4 mb-2">
                              <label className="fw-bold required mb-0-5">Case Category</label>
                              <input type="text" className="form-control" placeholder="Enter Case Category" {...register("CaseCategory", { required: "Case Category is required" })} defaultValue={selectedCaseCategory?.CaseCategory || ""} />
                              {errors.CaseCategory && <p className="text-danger required_error">{errors.CaseCategory.message}</p>}
                            </div>
                            <div className="col-md-4 mb-2">
                              <label className="fw-bold required mb-0-5">Sfdc Category Name</label>
                              <input type="text" className="form-control" placeholder="Sfdc Category Name" {...register("Sfdc_Category_Name", { required: "Sfdc Category is required" })} defaultValue={selectedCaseCategory?.Sfdc_Category_Name || ""} />
                              {errors.CaseCategory && <p className="text-danger required_error">{errors.CaseCategory.message}</p>}
                            </div>
                            <div className="col-md-4 mb-2">
                            <div className="row mt-4">
                              <div className="col-6">
                                <div className="form-check">
                                  <input type="checkbox" className="form-check-input" {...register("IsSRComplaint")} defaultChecked={selectedCaseCategory?.Record_Type_Ref_Id?.includes('0125j000001ZwwiAAC') || false} 
                                    value="0125j000001ZwwiAAC"
                                  />
                                  <label className="form-check-label fw-bold">Is SR Complaint</label>
                                </div>
                              </div>
                              <div className="col-6">
                                <div className="form-check">
                                  <input type="checkbox" className="form-check-input" {...register("IsSRRequest")} defaultChecked={selectedCaseCategory?.Record_Type_Ref_Id?.includes('0125j000001NdsXAAS') || false} 
                                    value="0125j000001NdsXAAS"
                                  />
                                  <label className="form-check-label fw-bold">Is SR Request</label>
                                </div>
                              </div>
                            </div>
                          </div>
                          </div>
                        </div>

                        <div className="modal-footer mt-0 mb-0 pt-1 pb-0 pr-1">
                          <button type="button" className="btn btn-danger" onClick={handleNewCaseCategoryModalClose}>Close</button>
                          <button type="submit" className="btn btn-primary">{selectedCaseCategory?.Id ? "Update" : "Save"}</button>
                        </div>

                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {newCaseCategoryMappingModal &&(
            <div className="modal-backdrop">
            <div className="modal fade show d-block" tabIndex="-1" role="dialog">
              <div className="modal-dialog modal-lg custom-modal" role="document">
                <div className="modal-content mb-0 p-0">
                  <div className="modal-header p-2-5">
                    <h5 className="modal-title">{selectedCaseCategory?.CaseCategory ? "Edit Case Category" : "New Case Category"}</h5>
                    <button type="button" className="btn-close" onClick={""}></button>
                  </div>
                  <div className="modal-body p-1">
                    <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
                      <ul className="nav nav-tabs mb-2">
                          <li className="nav-item">
                            <button type="button" className={`tab-button-header nav-link
                            ${activeTab === "srtype" ? "active highlighted-tab" : ""} `} 
                            onClick={() => setActiveTab("srtype")}>
                              SR Type
                              </button>
                          </li>
                          <li className="nav-item">
                            <button type="button" className={`tab-button-header nav-link 
                            ${activeTab === "location" ? "active highlighted-tab" : ""}`} 
                            onClick={() => setActiveTab("location")}>
                              Location
                            </button>
                          </li>
                          <li className="nav-item">
                            <button type="button" className={`tab-button-header  nav-link 
                            ${activeTab === "case_stage" ? "active highlighted-tab" : ""}`} 
                            onClick={() => setActiveTab("case_stage")}>
                              Case Stage
                              </button>
                          </li>
                      </ul>
                       {activeTab === "srtype" && (
                        <div className="row" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                          {/* {caseCategoryList.map((item, index) => item && item.IsActive ? ( */}
                            <div className="col-12" >
                              <div className="form-check d-flex align-items-center border-bottom pb-2 mb-2">
                              <label className="form-check-label fw-bold me-3">SR Type</label>

                                <div className="ms-auto">
                                {/* {item.IsSelected ?  */}
                                    
                                    <FaTrash color="red" className="mr-2 cursor-pointer" onClick={""} title="Delete Mapping" />
                                  {/* : <FaPlus color="green" className="mr-2 cursor-pointer" onClick={() =>handleMappingInsert(item.CaseCategory_Id)} title="Add Mapping" />
                                } */}
                                </div>
                              </div>
                          </div>
                          {/* ) : null
                        )} */}
                        </div>
                      )}
                      <div className="modal-footer mt-0 mb-0 pt-1 pb-0 pr-1">
                        <button type="button" className="btn btn-danger" onClick={handleNewCaseCategoryModalClose}>Close</button>
                        <button type="submit" className="btn btn-primary">{selectedCaseCategory?.Id ? "Update" : "Save"}</button>
                      </div>

                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          )}
    
          </CommonContainer >
        </>
      );
}

export default CaseCategoryComponent